import { Modal } from '@src/components/ui';
import { HiOutlineChatBubbleLeftRight } from 'react-icons/hi2';
import Support from '@src/pages/support';

declare global {
    interface Window {
        EasyForms?: any;
    }
}

interface SupportFormProps {
    open: boolean;
    onClose: () => void;
}

const SupportForm = ({ open, onClose }: SupportFormProps) => {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            title="Support"
            icon={<HiOutlineChatBubbleLeftRight />}
        >
            <Support onClose={onClose} />
        </Modal>
    );
};

export default SupportForm;